import { render, staticRenderFns } from "./DigitalRecipe.vue?vue&type=template&id=5da2fa70&scoped=true&"
import script from "./DigitalRecipe.vue?vue&type=script&lang=js&"
export * from "./DigitalRecipe.vue?vue&type=script&lang=js&"
import style0 from "./DigitalRecipe.vue?vue&type=style&index=0&id=5da2fa70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2fa70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
